export interface Category {
  id: number;
  namePl: string;
  nameEn: string;
  icon: string;
  link: string;
}

export const categories: Category[] = [
  {
    id: 1,
    namePl: 'Buty',
    nameEn: 'Shoes',
    icon: 'ri-footprint-line',
    link: 'https://kaspreadsheet.com/category-911-Shoes.html',
  },
  {
    id: 2,
    namePl: 'Bluzy / Swetry',
    nameEn: 'Hoodies/Sweaters',
    icon: 'ri-t-shirt-line',
    link: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
  },
  {
    id: 3,
    namePl: 'Koszulki',
    nameEn: 'T-Shirts',
    icon: 'ri-shirt-line',
    link: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
  },
  {
    id: 4,
    namePl: 'Kurtki',
    nameEn: 'Jackets',
    icon: 'ri-contrast-drop-line',
    link: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
  },
  {
    id: 5,
    namePl: 'Spodnie / Szorty',
    nameEn: 'Pants/Shorts',
    icon: 'ri-scissors-line',
    link: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
  },
  {
    id: 6,
    namePl: 'Nakrycia Głowy',
    nameEn: 'Headwear',
    icon: 'ri-user-smile-line',
    link: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
  },
  {
    id: 7,
    namePl: 'Zestawy',
    nameEn: 'Sets',
    icon: 'ri-stack-line',
    link: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
  },
  {
    id: 8,
    namePl: 'Bielizna',
    nameEn: 'Underwear/Underpants',
    icon: 'ri-heart-line',
    link: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
  },
  {
    id: 9,
    namePl: 'Koszulki Sportowe',
    nameEn: 'Jersey',
    icon: 'ri-basketball-line',
    link: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
  },
  {
    id: 10,
    namePl: 'Akcesoria',
    nameEn: 'Accessories',
    icon: 'ri-bear-smile-line',
    link: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
  },
  {
    id: 11,
    namePl: 'Torby',
    nameEn: 'Bags',
    icon: 'ri-shopping-bag-line',
    link: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
  },
  {
    id: 12,
    namePl: 'Paski',
    nameEn: 'Belts',
    icon: 'ri-link',
    link: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
  },
  {
    id: 13,
    namePl: 'Perfumy',
    nameEn: 'Perfumes',
    icon: 'ri-contrast-2-line',
    link: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
  },
  {
    id: 14,
    namePl: 'Inne Produkty',
    nameEn: 'Other Stuff',
    icon: 'ri-more-line',
    link: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
  },
];